import { motion } from "../components/StaticMotion";

export const SectionHero = () => {
  return (
    <section
      id="hero"
      className="relative w-full h-[65vh] md:h-[65vh] overflow-hidden bg-slate-900"
    >
      <img
        src="/bg/bghero1.jpg"
        alt="VionixAsia Hero Background"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-gray-900/90 to-gray-900/30" />

      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 gap-6">
        <motion.img
          src="/vionixwhite.png"
          alt="VionixAsia"
          className="h-24 md:h-32 object-contain"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        />
        <motion.p
          className="text-base md:text-lg font-normal text-white max-w-2xl mx-auto tracking-tight"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.75, delay: 0.15 }}
        >
          Integrated digital solutions for modern events — from registration and timing to live tracking and streaming for efficient, accurate, and engaging event operations.
        </motion.p>
      </div>
    </section>
  );
};
